var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-icon',{staticClass:"back-button",attrs:{"name":"back"},nativeOn:{"click":function($event){return _vm.jump.apply(null, arguments)}}})}
var staticRenderFns = []

export { render, staticRenderFns }